/**
 * @generated SignedSource<<3f61519656e7fa6b821e71657b29ce38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddComment$data = {
  readonly fullName: string | null;
  readonly picture: string | null;
  readonly " $fragmentType": "AddComment";
};
export type AddComment$key = {
  readonly " $data"?: AddComment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddComment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddComment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "09d0a3cdc67a5c6d886e743425fdb43f";

export default node;
